import { vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onMouseenter"];
const _hoisted_2 = {
  class: "point_pop"
};
const _hoisted_3 = {
  class: "point_inner"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.typeshowflag === 1 && _ctx.$attrs.typelist.length > 0 ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    class: _normalizeClass(["typeul", `fid${_ctx.$route.query.fid}`]),
    style: _normalizeStyle(_ctx.$attrs.posstyle),
    onMouseleave: _cache[0] || (_cache[0] = (...args) => $options.typeMouseLeave && $options.typeMouseLeave(...args))
  }, [_withDirectives(_createElementVNode("li", {
    style: _normalizeStyle($data.typeIndex === 0 ? $data.typebtn[1] : $data.typebtn[0]),
    class: "typeOne"
  }, " 各地展馆 ", 4), [[_vShow, _ctx.$attrs.showtypeall]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getChildren(_ctx.$attrs.typelist[1], 1), (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onMouseenter: $event => $options.typeMouseEnter($event, item, index, _ctx.$attrs.typelist[1])
    }, [_createElementVNode("span", {
      style: _normalizeStyle($data.typeIndex === index + 1 ? $data.typebtn[1] : $data.typebtn[0])
    }, _toDisplayString(item.title), 5)], 40, _hoisted_1);
  }), 128)), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typePointList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "title",
      key: item.id,
      onClick: $event => $options.typePointClick(item)
    }, [_createElementVNode("p", null, _toDisplayString(item.itemformdata.place_name), 1)], 8, _hoisted_4);
  }), 128))])], 512), [[_vShow, $data.pointpopFlag]])], 38)) : _createCommentVNode("", true), _ctx.$attrs.typeshowflag === 1 && _ctx.$attrs.typelist.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["right_typeul", `fid${_ctx.$route.query.fid}`])
  }, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$attrs.typelist[0].itemformdata.title), 1), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getChildren(_ctx.$attrs.typelist[0], 1), (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: _normalizeClass({
        'active': $data.childIndex === index
      }),
      onClick: $event => $options.childtypeClick(_ctx.$attrs.typelist[0], 1, item, index)
    }, [_createElementVNode("span", null, _toDisplayString(item.title), 1)], 10, _hoisted_6);
  }), 128))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "flag"
  }, null, -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "ship"
  }, null, -1))], 2)) : _createCommentVNode("", true)]);
}